import { TableCell as MUITableCell } from '@mui/material';

export const TableHeadCell = ({ children, align = 'left', ...props }) => {
  return (
    <MUITableCell
      className="!truncate !font-medium !text-[14px]/[20px] !text-base-1000 !text-nowrap !py-2 !px-3 !border-b !border-b-base-1000 !bg-neutral-100"
      align={align}
      {...props}
    >
      {children}
    </MUITableCell>
  );
};
